import { ActionCardData } from '../types'
import isConditionSatisfied from '../isConditionSatisfied'
import { ITagConditionEntity, ActionCardModel, BaseNode } from '../actionCard'

export function checkNodeVisibility(node: BaseNode, actionCardSource?: ActionCardModel | ActionCardData): boolean {
  const hierarchy = [node]

  // map all ancestors of a node to list
  while (hierarchy[0]?.parent) {
    hierarchy.unshift(hierarchy[0].parent)
  }

  // node if visible only if it and all its ancestors are visible
  return hierarchy.every(x => {
    return checkVisibility(x?.data, actionCardSource)
  })
}

export function checkVisibility(
  data: any | null | undefined,
  actionCardSource?: ActionCardModel | ActionCardData,
): boolean {
  const tagConditionEntity = (data ?? {}) as ITagConditionEntity

  const tagConditionResult = isConditionSatisfied(
    tagConditionEntity.tags || null,
    actionCardSource?.conditionalItems ?? [],
    tagConditionEntity.conditionRule || null,
  )

  if (!tagConditionResult) {
    return false
  }

  // if there are visibility rules, all must be satisfied, if there are no rules, node is visible
  return actionCardSource?.nodesVisibilityRules?.check(data, actionCardSource) ?? true
}
